import axios from 'axios';

const api = axios.create({
  baseURL: "https://admin.jayrajgroup.com/api",
  // baseURL: "https://admintest.jayrajgroup.org/api",
  // headers: {
  //   'X-API-TOKEN': '50cd682741a5119f4fc86830fe99960aaad2fb302377586ef753599def7af8b5'
  // }
});

export default api;